export default "__VITE_ASSET__BHo864qC__"